module.exports = __webpack_public_path__ + "static/img/specification.d1d94ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/specification.png
// module id = egHH
// module chunks = 0